import "./ml-list-table.scss";

import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {UseState}       from "@Common/react/use-state";
import {chain}          from "@Common/utils/fs";

import {CreateMailingListModal} from "../create-mailing-list-modal/create-mailing-list-modal";

import {CallingGetCass}       from "./calling-get-cass";
import {Columns}              from "./columns";
import {EditMailingListModal} from "./edit-mailing-list-modal/edit-mailing-list-modal";
import {MailingListRow}       from "./mailing-list-row";

export const MLListTable = (
    {
        mailingListIds, showHeaderSummary, countryCode, eddmUnavailable, mailingLists, showSource=true, itemId=undefined,
        agentId=undefined, branchId=undefined, isNDM=undefined,
        next,
    }
) => cs(
    consumeContext("apis"),
    ["selectedOnly", (_, next) => UseState({next})],
    ["filter", (_, next) => UseState({next})],
    ["createMailingListModal", ({}, next) => CreateMailingListModal({
        itemId,
        agentId,
        branchId,
        countryCode,
        isNDM,
        eddmUnavailable,
        onCreated: (mlIds, {autoSelect=true}={}) => {
            mailingLists.reload();
            if (autoSelect && mlIds?.length) {
                mailingListIds.change((_) => [..._??[], ...mlIds]);
            }
        },
        next,
    })],
    ["editMailingListModal", (_, next) => EditMailingListModal({entityId: agentId || branchId || '', next})],
    ["isSelected", (_, next) => next((ml) => mailingListIds.value?.find((id) => ml.id == id) != null)],
    ["usableMailingLists", ({isSelected}, next) => next(
        mailingLists.value?.filter((ml) => (
            (
                isSelected(ml) ||
                (
                    !(eddmUnavailable && ml.type === "saturation") &&
                    (ml.country === countryCode)
                )
            ) &&
            (!isNDM || ml.type === "saturation")
        ))
    )],
    ["filteredRecords", ({filter, selectedOnly, usableMailingLists, isSelected}, next) => next(usableMailingLists && chain(
        usableMailingLists,

        (_) => !filter.value ? _ : (
            _.filter((ml) => ml.mailingListName.toLowerCase().includes(filter.value.toLowerCase()))
        ),

        (_) => !selectedOnly.value ? (
            _
        ) : !mailingListIds.value?.length ? (
            []
        ) : (
            _.filter(isSelected)
        ),
    ))],
    ["callingGetCass", ({}, next) => CallingGetCass({mailingLists, mailingListIds: mailingListIds.value, entityId: agentId || branchId || '', next})],
    (
        {
            usableMailingLists, selectedOnly, filteredRecords, isSelected, filter,
            createMailingListModal, editMailingListModal, apis, callingGetCass,
        }
    ) => next({
        selectedOnly,
        filter,
        className: "mailing-addresses-table-0ta",
        showCreateMailingListModal: () => createMailingListModal.show(),
        columns: Columns({
            usableMailingLists,
            isSelected,
            filteredRecords,
            mailingListIds,
            showHeaderSummary,
            showSource,
        }),
        rows: filteredRecords?.map((ml) => ({
            key: ml.id,
            columns: MailingListRow({
                ml,
                mailingListIds,
                callingGetCass,
                showSource,
                onEdit: (ml) => {
                    editMailingListModal.show({
                        ml,
                        onChangeCount: () => mailingLists.reload(),
                    });
                },
                onRemove: async () => {
                    mailingListIds.change((_) => _.filter((id) => id != ml.id));
                    await apis.next.mailing.deleteMailingList({id: ml.id});
                    mailingLists.change((_) => _.filter((ml1) => ml1.id !== ml.id));
                },
            }),
            xdQaName: "Mailing List " + ml.mailingListName,
        })),
        emptyAction: (
            mailingLists.loading ? {
                label: "Loading..."
            } : selectedOnly.value ? {
                label: "No mailing list selected",
            } : {
                label: "Select or Create Address Lists for Your Order (required)",
                onClick: () => createMailingListModal.show(),
            }
        ),
    }),
);
